module.exports = __webpack_public_path__ + "ptc_momoro_B1.1e601d1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_B1.jpg
// module id = eyzk
// module chunks = 0